import { useMemo } from 'react';

import { useUser } from '@mopla/business-logic';
import { ISubscriptionTicket } from '@mopla/data-models';

interface IUseDTicketFirstAndLastNameProps {
	isJobticket: boolean;
	ticket?: ISubscriptionTicket;
}

export const useDTicketFirstAndLastName = ({
	isJobticket,
	ticket,
}: IUseDTicketFirstAndLastNameProps) => {
	const { userData } = useUser();

	const { firstName, lastName } = useMemo(() => {
		const first =
			(isJobticket &&
				(userData?.metaData?.jobticketFirstName as unknown as string)) ||
			ticket?.firstName ||
			userData?.firstName ||
			'';
		const last =
			(isJobticket &&
				(userData?.metaData?.jobticketLastName as unknown as string)) ||
			ticket?.lastName ||
			userData?.lastName ||
			'';
		return { firstName: first, lastName: last };
	}, [isJobticket, userData, ticket]);

	return { firstName, lastName };
};
